import { map } from 'rxjs/operators';
import { AdditionalOrderInformationTemplate } from '../models/additional-order-information-template.model';
import { AdditionalOrderInformationTemplateSchema } from '../schemas/additional-order-information-template.schema';
import { ApiObservable } from '../types/api-observable.type';
import { GraphqlService } from './graphql.service';
import { Injectable } from '@angular/core';

/**
 * AdditionalOrderInformationTemplate service
 */
@Injectable()
export class AdditionalOrderInformationTemplateService extends GraphqlService {
	/**
	 * Erstellt ein AdditionalOrderInformationTemplate
	 *
	 * @param data
	 */
	create(data: AdditionalOrderInformationTemplate): ApiObservable<AdditionalOrderInformationTemplate> {
		return this.mutation(AdditionalOrderInformationTemplateSchema.createAdditionalOrderInformationTemplate, {
			template: data
		}).pipe(map((response: any) => AdditionalOrderInformationTemplate.map(response.createAdditionalOrderInformationTemplate.template)));
	}

	/**
	 * Aktualisiert das AdditionalOrderInformationTemplate
	 *
	 * @param templateUid
	 * @param data
	 */
	update(templateUid: string, data: AdditionalOrderInformationTemplate): ApiObservable<AdditionalOrderInformationTemplate> {
		return this.mutation(AdditionalOrderInformationTemplateSchema.updateAdditionalOrderInformationTemplate, {
			uid: templateUid,
			template: data
		}).pipe(map((response: any) => AdditionalOrderInformationTemplate.map(response.updateAdditionalOrderInformationTemplate.template)));
	}

	/**
	 * Löscht das AdditionalOrderInformationTemplate
	 *
	 * @param templateUid Template Uid
	 */
	delete(templateUid: string): ApiObservable<AdditionalOrderInformationTemplate> {
		return this.mutation(AdditionalOrderInformationTemplateSchema.deleteAdditionalOrderInformationTemplate, {
			uid: templateUid
		}).pipe(map((response: any) => AdditionalOrderInformationTemplate.map(response.deleteAdditionalOrderInformationTemplate.template)));
	}
}
